import React, { Component } from 'react';

import PopulationLegend from '../Shared/PopulationLegend';
import DistrictsLegend from '../Shared/DistrictsLegend';
import { general } from '../../data';

const imgs = general.imgs;

class Answer extends Component {
  render() {
    return (
      <div className="gm-slide__challenge">
        <img className="gm-slide__icon" src={imgs.success_icon} />
        <p className="gm-slide__results-text">{this.props.text}</p>
        <div className="gm-slide__info-wrapper">
          <PopulationLegend a={ this.props.population[0] } b={ this.props.population[1] }/>
        </div>
        <img className="answer-image" src={ this.props.image } />
      </div>
    );
  }
}

export default Answer;



// WEBPACK FOOTER //
// ./src/components/Slides/Answer.js